<template>
    <el-container style="flex-basis: 0%">
        <el-header  class="tab-header" style="height:34px;" v-if="tabMode">
            <tab-views></tab-views>
        </el-header>
        <el-header style="padding: 0 5px; height: 34px;" v-if="!tabMode">
            <el-breadcrumb separator="/" class="header_breadcrumb">
                <el-breadcrumb-item v-for="(item,index) in breadcrumb" :key="index">{{item}}</el-breadcrumb-item>
            </el-breadcrumb>
        </el-header>
        <el-main class="body-main" v-if="tabMode && !isCachePage">
            <router-view v-if="isRouterAlive && cachePage.length > 0"></router-view>
        </el-main>
        <el-main class="body-main" v-if="tabMode && isCachePage">
            <keep-alive><router-view v-if="isRouterAlive && cachePage.length > 0"></router-view></keep-alive>
            <!--<keep-alive></keep-alive>-->
        </el-main>
        <el-main class="body-main" v-if="!tabMode">
            <router-view v-if="isRouterAlive"></router-view>
        </el-main>
        <modal-page/>
    </el-container>
</template>

<script>
    import TabViews from './tab-views'
    import { getSidebarMenu } from './sidebar';
    import ModalPage from '../components/modal-page';
    import KeepAlive from '../components/keep-alive';

    import appRoute  from '../../app.routes'
    export default {
        name: "WRouterView",
        props:{
            tabMode: {
                type: Boolean,
                default: false
            },
            isCachePage: {
                type: Boolean,
                default: true
            }
        },
        data(){
            return {
                currentRoute : null,
                init: false,
                isRouterAlive: true
            }
        },
        methods: {
            reload(){
                this.isRouterAlive = false;
                this.$nextTick(() => {
                    this.isRouterAlive = true;
                });
            },
            // getFirstRoute(){
            //     let currentRoute = null;
            //     if(this.enableRole){
            //         getSidebarMenu().some((item)=>{
            //             if(item.role && this.$isInRoles(item.role)){
            //                 if(item.children){
            //                     item.children.some((c)=>{
            //                         if(this.$isInRoles(c.role)){
            //                             currentRoute = c.index;
            //                             return true;
            //                         }
            //                     });
            //                     if(currentRoute) return true;
            //                 }else {
            //                     currentRoute = item.index;
            //                     return true;
            //                 }
            //             }
            //         });
            //     }else{
            //         getSidebarMenu().some((item)=> {
            //             if (item.children) {
            //                 item.children.some((c) => {
            //                     if (c.index) {
            //                         currentRoute = c.index;
            //                         return true;
            //                     }
            //                 });
            //                 if (currentRoute) return true;
            //             } else {
            //                 if (item.index) {
            //                     currentRoute = item.index;
            //                     return true;
            //                 }
            //             }
            //         });
            //     }
            //     return currentRoute;
            // },
            getFirstRoute(sidebarMenu){
                let currentRoute = null;
                if(this.enableRole){
                    // console.log('enableRole为true');
                    sidebarMenu.some((item)=>{
                        if(item.role && this.$isInRoles(item.role)){
                            if(item.children.length){
                                item.children.some((c)=>{
                                    if(this.$isInRoles(c.role)){
                                        currentRoute = c.index;
                                        return true;
                                    }
                                });
                                if(currentRoute) return true;
                            }else {
                                currentRoute = item.index;
                                return true;
                            }
                        }
                        else{
                            sidebarMenu.some((item)=> {
                                if (item.children.length) {
                                    item.children.some((c) => {
                                        if (c.index) {
                                            currentRoute = c.index;
                                            return true;
                                        }
                                    });
                                    if (currentRoute) return true;
                                } else {
                                    if (item.index) {
                                        currentRoute = item.index;
                                        return true;
                                    }
                                }
                            });
                        }
                    });
                }else{
                    sidebarMenu.some((item)=> {
                        if (item.children.length) {
                            item.children.some((c) => {
                                if (c.index) {
                                    currentRoute = c.index;
                                    return true;
                                }
                            });
                            if (currentRoute) return true;
                        } else {
                            if (item.index) {
                                currentRoute = item.index;
                                return true;
                            }
                        }
                    });
                }
                return currentRoute;
            },
            getRoute(path, appRoute) {
                let str = ""
                appRoute.forEach(item => {
                    if (item.path === path) {
                        return str = item.name
                    } else {
                        if (item.children) {
                            return str = this.getRoute(path, item.children)
                        }else {
                            return '404'
                        }
                    }
                })
                return str
            },
            getMenuRoute(name, getSidebarMenu) {
                // console.log(getSidebarMenu,'打印此时的menuData');
                let currentRoute = null;
                if(this.enableRole) {
                    getSidebarMenu.forEach(item => {
                        // console.log(item,'遍历出menuData里的item');
                        if (item.index === name && this.$isInRoles(item.role)) {
                            currentRoute = item.index
                            return true
                        } else {
                            if (item.children) {
                                currentRoute = this.getMenuRoute(name, item.children)
                                return true
                            } else {
                                return false
                            }
                        }
                    })
                    return currentRoute
                }
            }
        },
        created(){
            // console.log('每次进路由都会展示');
            if(this.tabMode){
                this.$store.commit('TAB_VIEW_ENABLED',true);
            }
            this.$bind('pageReload', () => {
                this.reload();
            });
        },
        mounted(){
            // console.log(this.$route.meta)
            setTimeout(()=>{
                let path = location.hash.substring(1).split('?')[0]
                let name =  this.getRoute(path, this.appRoute);
                if (name === '404') {
                    this.$message.error({type: 'warning', message: '路由错误'});
                    this.$router.push('/');
                } else {
                    let sidebarMenu=getSidebarMenu()
                    // console.log(sidebarMenu,'打印一下能否获取到目录');
                    this.getMenuRoute(name, sidebarMenu);
                    let query = {};
                    let queryStr = location.hash.substring(1).split('?')[1]
                    if (queryStr) {
                        let queryArr = queryStr.split("&");
                        queryArr.forEach(item => {
                            if (item.split("=")[0] !== "_") {
                                query[item.split("=")[0]] = item.split("=")[1]
                            }
                        })
                    }
                    if (path === "/") {
                        let currentRoute = this.getFirstRoute(sidebarMenu);
                        if(currentRoute){
                            this.$router.push({name:currentRoute});
                        }else {
                            this.$message({type: 'warning', message: '无相关权限请联系管理员'});
                        }
                    } else {
                        let timer = setTimeout(() => {
                            clearTimeout(timer)
                            this.$router.push({path, query})
                        },1000)
                    }
                }
            },100)
        },
        computed: {
            cachePage(){
                return this.$store.state.tabView.pages.map(item => item.name);
            },
            breadcrumb(){
                return this.$store.state.breadcrumb.breadcrumb;
            },
            appRoute(){
                return JSON.parse(window.localStorage.getItem('wedof-itsm__router'))
            },
            // keepAliveStr(){
            //     return this.$store.state.keepAlive
            // }
        },
        components: {TabViews, ModalPage, KeepAlive}
    }
</script>

<style >
    .header_breadcrumb{
        padding: 12px;
    }

    .header_breadcrumb .el-breadcrumb__inner{
        font-weight: normal !important;
        cursor: inherit !important;
        color: #606266 !important;
    }

</style>
